import React from 'react';
import CPOControls from './CPOControls';
import { useCPOContext } from '../contexts/CPOContext';
import './CPOPanel.css';

const CPOPanel = ({ 
  orientacionSeleccionada,
  onSelectOrientacion,
  listaOrientaciones,
  cpcAprobadasCount,
  cpoPuntos,
  // Soportar ambas APIs para compatibilidad
  onClose,
  toggleMostrarCPOpanel,
  onPuntosChange,
  hasConfirmedRequirements,
  materias,
  updateMateriaEstado,
  updateNotaFecha,
}) => {
  // Derivar puntos y cpc en vivo desde hook (persistencia automática)
  const { puntos, cpcCursadas, setOrientacion, resetCPO } = useCPOContext();
  return (
    <div className="cpo-panel">
      {/* Header */}
      <div className="cpo-panel-header">
        <div className="cpo-panel-header-content">
          <h3>
            🎯 Configuración CPO - Orientación
          </h3>
          <p>
            Elegí tu orientación y seguí tu progreso hacia los 69 puntos
          </p>
        </div>
        
        {/* Botón cerrar */}
        <button
          onClick={onClose || toggleMostrarCPOpanel}
          className="cpo-panel-close-btn"
          title="Cerrar panel CPO"
        >
          ✕
        </button>
      </div>

      {/* Contenido */}
      <div className="cpo-panel-content">
        <div className="cpo-controls-panel-wrapper">
          <CPOControls
            orientacionSeleccionada={orientacionSeleccionada}
            onSelectOrientacion={(o) => {
              onSelectOrientacion && onSelectOrientacion(o);
              // Normalizar SIEMPRE al nombre visible que usa careerLogic: "CPO Orientación ${nombre}"
              if (typeof o === 'string') {
                setOrientacion(o);
              } else if (o && o.nombre) {
                setOrientacion(o.nombre);
              }
            }}
            listaOrientaciones={listaOrientaciones || []}
            cpcAprobadasCount={cpcAprobadasCount || cpcCursadas || 0}
            cpoPuntos={{
              total: 0,
              orientacionPrincipales: 0,
              orientacionDerivadas: 0,
              constitucionalProfundizado: 0,
              procesalObligatorio: 0,
              integracion: 0,
              practico: 0,
              libresGeneralesCPO: 0,
              filosofia: 0,
              sociales: 0,
              procesalLibre: 0,
              ...(puntos || {}),
              ...cpoPuntos
            }}
            onPuntosChange={onPuntosChange}
            hasConfirmedRequirements={hasConfirmedRequirements || false}
            materias={materias}
            updateMateriaEstado={updateMateriaEstado}
          />
        </div>
      </div>

      {/* Footer con información útil */}
      <div className="cpo-panel-footer">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div>
            {listaOrientaciones && listaOrientaciones.length > 0 ? (
              `💡 Orientaciones disponibles: ${listaOrientaciones.length} | Necesitás 69 puntos CPO para graduarte`
            ) : (
              '⚠️ Cargando orientaciones...'
            )}
          </div>
          <button
            className="cpo-panel-close-btn"
            onClick={resetCPO}
            title="Borrar progreso CPO"
          >
            Borrar progreso CPO
          </button>
        </div>
      </div>
    </div>
  );
};

export default CPOPanel; 